import type { DealStage } from "../types";

export type DealPipeline = {
  quoteWorkflow?: {
    sentStage: string;
    agreementStage: string;
    managerStage?: string;
  };
  value: string;
  label: string;
  stages: DealStage[];
  wonStages: string[];
  lostStages: string[];
};

export const dealPipelines: DealPipeline[] = [
  {
    value: "catalog",
    label: "Продажа мебели",

    stages: [
      {
        value: "catalog-new",
        label: "Новая заявка",
      },
      {
        value: "catalog-contacted",
        label: "Связались",
      },
      {
        value: "catalog-calculation",
        label: "Расчёт",
      },
      {
        value: "catalog-proposal-sent",
        label: "КП отправлено",
      },
      {
        value: "catalog-negotiation",
        label: "Переговоры",
      },
      {
        value: "catalog-contract",
        label: "Договор",
      },
      {
        value: "catalog-prepayment",
        label: "Предоплата",
      },

      // Реализация заказа
      {
        value: "catalog-order-created",
        label: "Заказ создан",
      },
      {
        value: "catalog-design",
        label: "Проектирование",
      },
      {
        value: "catalog-approval",
        label: "Согласование",
      },
      {
        value: "catalog-production-preparation",
        label: "Подготовка к производству",
      },
      {
        value: "catalog-production",
        label: "Производство",
      },
      {
        value: "catalog-ready",
        label: "Готов",
      },
      {
        value: "catalog-delivery",
        label: "Доставка",
      },
      {
        value: "catalog-installation",
        label: "Монтаж",
      },
      {
        value: "catalog-completed",
        label: "Завершено",
      },

      {
        value: "catalog-lost",
        label: "Закрыто без продажи",
      },
    ],

    wonStages: ["catalog-completed"],
    lostStages: ["catalog-lost"],
  },

  {
    value: "bureau",
    label: "Конструкторское бюро",

    stages: [
      {
        value: "bureau-new",
        label: "Новое обращение",
      },
      {
        value: "bureau-contacted",
        label: "Связались",
      },
      {
        value: "bureau-brief",
        label: "Получен бриф",
      },
      {
        value: "bureau-estimate",
        label: "Предварительный расчёт",
      },
      {
        value: "bureau-proposal",
        label: "Предложение отправлено",
      },
      {
        value: "bureau-negotiation",
        label: "Переговоры",
      },
      {
        value: "bureau-contract",
        label: "Договор",
      },
      {
        value: "bureau-prepayment",
        label: "Предоплата",
      },

      // Реализация проекта
      {
        value: "bureau-project-created",
        label: "Проект создан",
      },
      {
        value: "bureau-design",
        label: "Проектирование",
      },
      {
        value: "bureau-approval",
        label: "Согласование",
      },
      {
        value: "bureau-documentation",
        label: "Подготовка документации",
      },
      {
        value: "bureau-production-preparation",
        label: "Подготовка к производству",
      },
      {
        value: "bureau-production",
        label: "Производство",
      },
      {
        value: "bureau-ready",
        label: "Готов",
      },
      {
        value: "bureau-delivery",
        label: "Доставка",
      },
      {
        value: "bureau-installation",
        label: "Монтаж",
      },
      {
        value: "bureau-completed",
        label: "Завершено",
      },

      {
        value: "bureau-lost",
        label: "Закрыто без продажи",
      },
    ],

    wonStages: ["bureau-completed"],
    lostStages: ["bureau-lost"],
  },
];

export const defaultDealPipeline = dealPipelines[0];

export function getDealPipeline(
  pipeline?: string,
  pipelines: DealPipeline[] = dealPipelines,
) {
  return (
    pipelines.find((item) => item.value === pipeline) ??
    pipelines[0] ??
    defaultDealPipeline
  );
}
